import React, { useCallback, useMemo } from 'react';
import { Popconfirm, Form, Space, DatePicker } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { PlusOutlined, DeleteTwoTone } from '@ant-design/icons';
import { isNil, sumBy } from 'lodash';
import moment from 'moment';
import { dateToString, indexBy, shouldUpdateCompare } from 'utils/utils2';
import { useFormList } from 'hooks/useFormList';
import Value from 'components/Value';
import Button from 'components/Button';
import DataGrid from 'components/DataGrid';
import ParListSelect from 'components/ParListSelect';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { SuppInvoiceScheduleResponse } from 'services/supplierInvoice';
import ParBankAccountSelect from 'components/ParBankAccountSelect';
import SIBeneficiarySelect from './SIBeneficiarySelect';
import ButtonOperation from 'components/ButtonOperation';
import FormInput from 'components/FormInput';
import { toCurrency } from 'utils/utils';
import InputCurrency from 'components/InputCurrency';
import { findSIBeneficiary } from 'services/thirdParty';
import _ from 'lodash';

type TabSuppInvoiceSchedulesProps = {
  form: FormInstance;
  siid: number | undefined;
};

const TabSuppInvoiceSchedules = (props: TabSuppInvoiceSchedulesProps) => {
  const { form, siid } = props;

  const fieldName = 'suppInvoiceSchedules';

  const { add, remove } = useFormList(form, fieldName, {
    addAsFirst: true,
    idKey: 'sisid',
  });

  if (form.getFieldValue(fieldName) === undefined) {
    form.setFieldsValue({
      [fieldName]: [],
    });
  }
  const mgidd = localStorage.getItem('mgid');
  const getName = useCallback(
    (name: string) => (record: SuppInvoiceScheduleResponse) => {
      const schedules = form.getFieldValue(fieldName);
      const index = indexBy(schedules, 'sisid')[record.sisid];
      return [fieldName, index, name];
    },
    [form]
  );
  const addRow = async () => {
    const totalInvoiceAmount: number = form.getFieldValue('sigrosstotal');
    const totalPaymentsScheduled: number = form.getFieldValue('sisamount');
    let leftAmount: number = totalInvoiceAmount;

    if (sumBy(fieldName, 'sisamount') && totalPaymentsScheduled) {
      leftAmount = totalPaymentsScheduled - totalInvoiceAmount;
    }
    const sisamount = totalPaymentsScheduled
      ? leftAmount - totalPaymentsScheduled
      : leftAmount;

    let benef: any;
    await findSIBeneficiary({
      tpid: Number(form.getFieldValue('supplier')?.tpid),
      role: 'SUPPLIER',
      ctrid: form.getFieldValue('ctrid'),
    }).then((resp) => {
      benef = resp.list?.find(
        (benf: any) =>
          benf.tpid === Number(form.getFieldValue('supplier')?.tpid)
      );
    });

    let newDatebenef = moment();
    let documentDate = form.getFieldValue('sidocdate');

    if (!isNil(benef?.tppaydelayout))
      newDatebenef = moment(documentDate).add(
        benef?.tppaydelayout
          ?.replace('M', '')
          .substr(1, benef?.tppaydelayout?.length),
        'days'
      );

    if (benef?.tppaydelayout?.indexOf('M') > -1) {
      newDatebenef = moment(documentDate)
        .add(
          benef?.tppaydelayout
            ?.replace('M', '')
            .substr(1, benef?.tppaydelayout?.length),
          'days'
        )
        .endOf('month');
    }
    const newsisorder = form.getFieldValue(fieldName).length + 1;

    const item: any = {
      siscategory: '',
      sislabel: '',
      sisid: Math.round(_.random(10000) * 10000000),
      sisamount,
      sisdueamount: sisamount,
      sisduedate: newDatebenef as any,
      sisorder: newsisorder,
      sispaymentdelaycode: benef?.tppaydelayout,
      sispaymentmode: benef?.tppaymodeout,
      sisstatus: 'INIT',
      sistype: 'PAYMENT',
      mgbankaccount: '',
      tpidbeneficiary: form.getFieldValue('supplier').tpid,
      tpbeneficiarybankaccount: benef?.tpbklist.find(
        (bk: any) =>
          bk.bkstatus === 'VALID' && ['INOUT', 'OUT'].includes(bk.bktype)
      )?.tpbkid,
      sispercentage: 0,
      ctrid: form.getFieldValue('ctrid'),
    };
    add(item);
    recalculate(0, { cisamont: 0 });
  };

  const recalculate = useCallback(
    (index: number, updatedValues: any) => {
      const values = form.getFieldValue(
        fieldName
      ) as SuppInvoiceScheduleResponse[];

      const newValues = values.map((item, i) => {
        if (i !== index) {
          return item;
        }

        const updatedItem = { ...item, ...updatedValues };

        const sisamount = updatedItem.sisamount;
        const sisdueamount = updatedItem.sisamount;

        return {
          ...updatedItem,
          sisamount,
          sisdueamount,
        };
      });

      const sisamount = sumBy(newValues, 'sisamount');

      form.setFieldsValue({
        [fieldName]: newValues,
        sisamount,
      });
    },
    [form]
  );

  // useEffect(() => {
  //
  //   if (form.getFieldValue('tppid')) {

  //   }
  // }, [form]);
  const insertbeneficiary = (obj: any, index: any) => {
    const values = form.getFieldValue(
      fieldName
    ) as SuppInvoiceScheduleResponse[];
    const newValues = values.map((item, i) => {
      if (i !== index) {
        return item;
      }

      let newDate = '' as any;
      let documentDate = form.getFieldValue('sidocdate');

      siid
        ? (newDate = moment(documentDate).add(
            obj?.tppaydelayout
              ?.replace('M', '')
              .substr(1, obj?.tppaydelayout?.length),
            'days'
          ))
        : (newDate = moment(documentDate).add(
            obj?.tppaydelayout
              ?.replace('M', '')
              .substr(1, obj?.tppaydelayout?.length),
            'days'
          ));

      if (obj?.tppaydelayout?.indexOf('M') > -1) {
        newDate = moment(documentDate).endOf('month');
      }
      const updatedItem = {
        ...item,
        tpbeneficiarybankaccount: obj?.tpbklist.find(
          (bk: any) =>
            bk.bkstatus === 'VALID' && ['INOUT', 'OUT'].includes(bk.bktype)
        )?.tpbkid,
        sispaymentdelaycode: obj?.tppaydelayout,
        sispaymentmode: obj?.tppaymodeout,
        tpidbeneficiary: obj?.tpid,
        sisduedate: newDate,
      };

      const sisamount = updatedItem.sisamount;
      const sisdueamount = updatedItem.sisamount;

      return {
        ...updatedItem,
        sisamount,
        sisdueamount,
      };
    });
    form.setFieldsValue({
      [fieldName]: newValues,
    });
  };
  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        comcode: 'SILinesSchedule.sistype',
        key: 'siltype',
        width: 150,
        fixed: 'left',
        render: (_, record, index) => (
          <Form.Item name={getName('sistype')(record)}>
            <ParListSelect parcode="SISTYPE" />
          </Form.Item>
        ),
      },
      {
        comcode: 'SILinesSchedule.tpidbeneficiary',
        key: 'tpidbeneficiary',
        width: 150,
        render: (val, record, index) => {
          return (
            <Form.Item shouldUpdate>
              {({ getFieldValue }) => (
                <FormInput name={getName('tpidbeneficiary')(record)} noStyle>
                  <SIBeneficiarySelect
                    allowClear
                    onSelected={(e) => {
                      insertbeneficiary(e, index);
                    }}
                    ctrid={record.ctrid}
                    tpid={
                      record.tpidbeneficiary ?? getFieldValue('supplier').tpid
                    }
                    maintpid={
                      record.sistype === 'WITHTAX'
                        ? record.tpidbeneficiary
                        : record.maintpidbeneficiary
                    }
                  />
                </FormInput>
              )}
            </Form.Item>
          );
        },
      },
      {
        comcode: 'SILinesSchedule.sisamount',
        dataIndex: 'sisamount',
        width: 150,
        align: 'right',
        render: (_value, _record, index) => (
          <Form.Item name={getName('sisamount')(_record)}>
            <InputCurrency
              onChange={(value) => recalculate(index, { sisamount: value })}
              currcode={form.getFieldValue('currcode')}
            />
          </Form.Item>
        ),
      },
      {
        comcode: 'SILinesSchedule.sispaymentdelaycode',
        key: 'sispaymentdelaycode',
        width: 180,
        render: (_, record, index) => (
          <Form.Item
            name={getName('sispaymentdelaycode')(record)}
            rules={[{ required: true }]}
          >
            <ParListSelect
              parcode="PAYDELAYOU"
              onChange={(value) => {
                let newDate = '' as any;
                let documentDate = form.getFieldValue('sidocdate');

                newDate = moment(documentDate).add(
                  value.replace('M', '').substr(1, value.length),
                  'days'
                );

                if (value.indexOf('M') > -1) {
                  newDate = moment(documentDate)
                    .add(value.replace('M', '').substr(1, value.length), 'days')
                    .endOf('month');
                }
                recalculate(index, {
                  sisduedate: newDate,
                });
              }}
            />
          </Form.Item>
        ),
      },
      {
        comcode: 'SILinesSchedule.sisduedate',
        key: 'sisduedate',
        width: 150,
        render: (_, record, index) => (
          <Form.Item name={getName('sisduedate')(record)}>
            {siid ? (
              dateToString(moment(record.sisduedate))
            ) : (
              <DatePicker value={moment(record?.sisduedate)} />
            )}
          </Form.Item>
        ),
      },
      {
        comcode: 'SILinesSchedule.sispaymentmode',
        key: 'sispaymentmode',
        width: 150,
        render: (_, record, index) => (
          <Form.Item
            name={getName('sispaymentmode')(record)}
            rules={[{ required: true }]}
          >
            <ParListSelect parcode="PAYMODEOUT" />
          </Form.Item>
        ),
      },
      {
        comcode: 'SILinesSchedule.tpbeneficiarybankaccount',
        key: 'tpbeneficiarybankaccount',
        width: 150,
        render: (_, record, index) => {
          return (
            <Form.Item noStyle shouldUpdate>
              {({ getFieldValue }) => (
                <Form.Item name={getName('tpbeneficiarybankaccount')(record)}>
                  <SIBeneficiarySelect
                    allowClear
                    bankaccount
                    ctrid={record.ctrid}
                    tpid={
                      record.tpidbeneficiary ?? getFieldValue('supplier').tpid
                    }
                    maintpid={
                      record.sistype === 'WITHTAX'
                        ? record.tpidbeneficiary
                        : record.maintpidbeneficiary
                    }
                  />
                </Form.Item>
              )}
            </Form.Item>
          );
        },
      },
      {
        comcode: 'SILinesSchedule.mgbankaccount',
        key: 'mgbankaccount',
        width: 150,
        render: (_, record, index) => (
          <Form.Item shouldUpdate={shouldUpdateCompare('currcode')} noStyle>
            {({ getFieldValue }) => (
              <Form.Item name={getName('mgbankaccount')(record)}>
                <ParBankAccountSelect
                  mgid={Number(mgidd)}
                  direction="OUT"
                  currcode={getFieldValue('currcode')}
                />
              </Form.Item>
            )}
          </Form.Item>
        ),
      },
      {
        comcode: 'SILinesSchedule.sisstatus',
        key: 'sisstatus',
        width: 120,
        align: 'right',
        render: (_value, _record, index) => (
          <Form.Item name={getName('sisstatus')(_record)}>
            <Value />
          </Form.Item>
        ),
      },
      {
        comcode: 'SILinesSchedule.sisdueamount',
        key: 'sisdueamount',
        render: (_value, _record, index) => (
          <Form.Item name={getName('sisdueamount')(_record)}>
            <Value
              formatter={(val) =>
                toCurrency(val, form.getFieldValue('currcode'))
              }
            />
          </Form.Item>
        ),
        width: 120,
        align: 'right',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form, mgidd, recalculate, siid]
  );

  if (
    (siid === undefined || form.getFieldValue('sistatus') === 'INIT') &&
    !columns.find((col) => col.key === 'actions')
  ) {
    columns.push({
      title: 'Actions',
      key: 'actions',
      render: (_value, record) => (
        <Popconfirm
          title="Sure to delete?"
          onConfirm={() => {
            form.setFieldsValue({
              sisamount: form.getFieldValue('sisamount') - record.sisamount,
            });
            remove(record.sisid);
          }}
        >
          <Button
            comcode="delete"
            size="small"
            icon={<DeleteTwoTone twoToneColor="#eb2f96" />}
          />
        </Popconfirm>
      ),
      fixed: 'right',
      width: 120,
    });
  }

  const title = (
    <Form.Item
      noStyle
      shouldUpdate={shouldUpdateCompare([
        'sisamount',
        'sigrosstotal',
        'currcode',
      ])}
    >
      {({ getFieldValue }) => {
        return (
          <Space size={16}>
            <span style={{ color: '#668cff' }}>
              Total Invoice Amount :{' '}
              {toCurrency(
                getFieldValue('sigrosstotal'),
                getFieldValue('currcode')
              )}
            </span>
            <strong
              style={{
                color:
                  getFieldValue('sisamount') === getFieldValue('sigrosstotal')
                    ? 'green'
                    : getFieldValue('sisamount') > getFieldValue('sigrosstotal')
                    ? 'red'
                    : 'orange',
              }}
            >
              Total Payments Scheduled:{' '}
              {toCurrency(
                getFieldValue('sisamount'),
                getFieldValue('currcode')
              )}
            </strong>
          </Space>
        );
      }}
    </Form.Item>
  );

  return (
    <Form.Item
      noStyle
      shouldUpdate={shouldUpdateCompare(['suppInvoiceSchedules', 'sistatus'])}
    >
      {({ getFieldValue }) =>
        siid === undefined || getFieldValue('sistatus') === 'INIT' ? (
          <DataGrid
            title={title}
            columns={columns}
            dataSource={getFieldValue(fieldName)}
            rowKey="sisid"
            hideFilters
            extraActions={
              <ButtonOperation
                icon={<PlusOutlined />}
                type="primary"
                onClick={addRow}
                comcode="add"
              />
            }
          />
        ) : (
          <DataGrid
            title={title}
            columns={columns}
            dataSource={getFieldValue(fieldName)}
            rowKey="sisid"
          />
        )
      }
    </Form.Item>
  );
};

export default TabSuppInvoiceSchedules;
